import { getAxiosInstance } from "../ApiConfig";

async function DealTypeAPi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealType`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllDeal() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealsByReportingUsers`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllDealPagination(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealsByReportingUsers?page=${page}&limit=${limit}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllDealSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealsByReportingUsers?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllDealPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealsByReportingUsers?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function PriorityDealApi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllPriority`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function HoldReasonapi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealHoldReason`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function LostReasonApi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealLostReason`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function wonReasonApi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealWonReason`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllPipeline() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllPipelineStage`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchDealDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByDealsId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchDealByAccount(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllActiveDealByAccount/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchDealByContact(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllDealsByContact/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function DealUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateDeals/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function DealScoreData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchDealScoreByDealId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massUpdateDeal(payload) {
    try {
         const { actionType, ...body } = payload;
                const url = actionType
                    ? `/usermgmt/massUpdateDeal?actionType=${actionType}`
                    : `/usermgmt/massUpdateDeal`;
                const response = await getAxiosInstance().put(url, body);
                return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massDeleteDeals(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/massDeleteDeals`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createDeals(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createDeals`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    massUpdateDeal,
    massDeleteDeals,
    DealTypeAPi,
    wonReasonApi,
    LostReasonApi,
    HoldReasonapi,
    PriorityDealApi,
    FetchAllDeal,
    FetchAllPipeline,
    FetchDealDetails,
    FetchDealByContact,
    FetchDealByAccount,
    DealUpdate,
    DealScoreData,
    AllDealPagination,
    AllDealPaginationSearch,
    FetchAllDealSearch,
    createDeals,
}